<template>
  <div id="pvf1" style="height:100%;width:100%">
    <div id="sel" style="height: 10%; width: 100%">
      <el-select
        v-model="selectedBU"
        style="right: -20px"
        placeholder="所有BU"
        @change="refreshPlantList()"
      >
        <el-option
          v-for="item in BUList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-select
        id="selectedPlant"
        v-model="selectedPlant"
        multiple
        filterable
        clearable
        placeholder="所有工厂"
      >
        <el-option
          v-for="item in PlantList"
          :key="item.PlantCode"
          :label="item.PlantName"
          :value="item.PlantCode"
        ></el-option>
      </el-select>

      <el-button-group>
        <el-button
          :type="activeChartGroup == 'chart' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'chart'"
          icon="el-icon-s-data"
          @click="onChartGroupChanged('chart')"
        ></el-button>
        <el-button
          :type="activeChartGroup == 'table' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'table'"
          icon="el-icon-s-grid"
          @click="onChartGroupChanged('table')"
        ></el-button>
        <el-button
          :type="activeChartGroup == 'detail' ? 'primary' : 'success'"
          plain
          :disabled="activeChartGroup == 'detail'"
          icon="el-icon-document"
          @click="onChartGroupChanged('detail')"
        ></el-button>
      </el-button-group>

      <el-date-picker
        v-model="selectedDateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-input
        v-model="FilterNumber"
        style="width: 80px"
        placeholder="前N"
      ></el-input>
      <el-button type="success" plain @click="loadDataList()">查询</el-button>
    </div>
    <div style="height:850px;width:100%">
      <div id="myChartPVF" style="height:800PX;width: 950px"></div>
      <div id="myChartPVF2" style="height:800PX;width: 950px"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";
import topHeader from "../TopMenu/topHeader.vue";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";

export default {
  name: 'pvf1',
  data() {
    return {
      activeName: "first",
      PageTitle: "搪塑线对标",
      DataList: {},
      PlantList: [],
      AreaList: AREA_LIST,
      BUList: BU_LIST,
      selectedArea: "GLOBAL",
      selectedBU: "",
      selectedPlant: "",
      selectedBranch: "",
      selectedTon: "",
      selectedEquipment: "",
      selectedDateRange: "",
      selectedFilterBy: "",
      activeChartGroup: "chart",
      activeCategory: "rate",
      activeColumnGroup: "energy",
      selectedFilterOrder: "desc",
      FilterNumber: "10",
       FilterListCategory: {
        kpi: [
          { value: "kpi_minute", label: "分钟单耗" },
          { value: "kpi_kg", label: "公斤单耗" },
          { value: "kpi_mold", label: "模单耗" },
        ],
        rate: [
          { value: "rate_cost", label: "能源利用率" },
          { value: "rate_time", label: "时间利用率" },
        ],
        pvf: [
          { value: "pvf_peak", label: "峰时占比" },
          { value: "pvf_flat", label: "平时占比" },
          { value: "pvf_valley", label: "谷时占比" },
          { value: "pvf_avg_cost", label: "均价" },
        ],
      },
      FilterOrder: [
        { value: "desc", label: "从大到小" },
        { value: "asc", label: "从小到大" },
      ],
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      chartTitle: '峰平谷生产时间利用率(%) & 平均电价',
      dataset: [],
      dataLabel: [],
      equipDesc: [],
      shadowBar: [],
      pvfBasePrice: []
    };
  },
  created() {},
  mounted() {
      //   mounted 函数表示已经DOM渲染完成
    const { loadDataList, refreshDataOnChange, refreshPlantList } = this;
    var day1 = new Date();
    day1.setDate(1);
    var day2 = new Date();
    //day2.setTime(day2.getTime()-24*60*60*1000)
    this.selectedDateRange = [day1, day2];

    // this.selectedFilterBy = this.FilterListCategory[this.activeCategory][0].value
    loadDataList();
  },
  methods: {
  refreshPlantList() {
      const { loadDataList, refreshDataOnChange } = this;

      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU
      }
      const queryArgs = { QueryAreaName: this.selectedArea, QueryBU: selBu, QueryFilterBy: 'IsUpload' }
      request({
        url: 'Kanban/PlantList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        console.log(res)
        this.PlantList = res.data.Data.PlantList
      })
    },
    //加载数据
   loadDataList() {
      const { formatDate } = this;

      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU
      }
      let selPlant = ''
      if (this.selectedPlant !== undefined && this.selectedPlant !== '') {
        selPlant = this.selectedPlant.join()
      }
      let selEquip = ''
      if (this.selectedEquipment !== undefined && this.selectedEquipment !== '') {
        selEquip = this.selectedEquipment.join()
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea, 
        QueryBU: selBu, 
        QueryPlantCode: selPlant,
        QueryManufacturerType: this.selectedBranch,
        QueryTonnageType: this.selectedTon,
        QueryEquipment: selEquip,
        QueryFilterBy: this.selectedFilterBy,
        QueryOrderAsc: this.selectedFilterOrder,
        QueryFilterOrder: this.FilterNumber,
        QueryDataCategory: this.activeCategory,
        QueryDetailData: (this.activeChartGroup == 'detail' ? 'Y' : '')
      }
      if (this.selectedDateRange != undefined && this.selectedDateRange.length > 1) {
        queryArgs.QueryStartMonth = formatDate(this.selectedDateRange[0])
        queryArgs.QueryEndMonth = formatDate(this.selectedDateRange[1])
      }

      request({
        url: 'Kanban/plasticining_DataList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.DataList = res.data.Data
         console.log("搪塑数据",res.data)
         console.log("搪塑数据2",response)
         console.log("搪塑数据3",this.DataList)
       this.refreshChartPVF(this.DataList);
         
      })
    },
   formatDate(date) {
      var y = date.getFullYear();
      var m = (date.getMonth() + 1);
      if (m < 10)
          m = "0" + m;
      var d = date.getDate();
      if (d < 10)
          d = "0" + d;
      var s = y + "-" + m + "-" + d;
      return s;
    },

    refreshChartPVF(va) {
      const serColors = ['#FCAE63', '#D2EAB6', '#C1E7FD', '#8E8E38', '#008B45', '#6aa36a']
      var that = this
      var pvfData = va[1].pldb;
      const data1 = []
      const data2 = []
      const data3 = []
      const data4 = []
      const data5 = []
      const titleData = []
      const equipDesc = []
      this.dataset = []
      this.shadowBar = []
      this.pvfBasePrice = []
       if (pvfData !== undefined) {
        for (let i = 0; i < pvfData.length; i++) {
          //  if (queryArgs.QueryGroupBy == 'Day') {
          //    var vDay = chartData[i].Day.substring(5, 10)
          //    titleData.push(vDay)
          //  } else {
             titleData.push(pvfData[i].PlantCode + '\n' + pvfData[i].EquipmentName)
           //}

          // if (queryArgs.QueryColumnGroup == 'energy') {
            data1.push(pvfData[i].EnergyValuePeakRate)
            data2.push(pvfData[i].EnergyValueNormalRate)
            data3.push(pvfData[i].EnergyValueValleyRate)
          // } else {
          //   data1.push(pvfData[i].WorkTimePeakRate)
          //   data2.push(pvfData[i].WorkTimeNormalRate)
          //   data3.push(pvfData[i].WorkTimeValleyRate)
          // }
          data4.push(pvfData[i].EnergyAvgPrice)
          data5.push(pvfData[i].EnergyOptimalPrice)
          this.pvfBasePrice.push([pvfData[i].BasePriceLow, pvfData[i].BasePriceUp, pvfData[i].BasePriceLow, pvfData[i].BasePriceUp])
          this.shadowBar.push(100)
          equipDesc.push(pvfData[i].PlantName + '<br/>' + pvfData[i].EquipmentName + '<br/>' + pvfData[i].ManufacturerType + '<br/>' + pvfData[i].TonnageType)
        }
      }
      this.dataset = [data1, data2, data3, data4, data5]
      this.dataLabel = titleData
      this.equipDesc = equipDesc

      // if (queryArgs.QueryColumnGroup == 'energy') {
      //   this.chartTitle = '能耗占比(%) & 平均电价'
      // } else {
        this.chartTitle = '生产时间利用率(%) & 平均电价'
     // }

      var zoomConfig = []
      var iZoomLength = 8
      if (data1.length > iZoomLength) {
        zoomConfig.push({
          type: 'slider',
          show : true,
          realtime : true,
          start: 0,
          end: iZoomLength / data1.length * 100
          },{
          type: 'inside',
          show : true,
          realtime : true,
          start: 0,
          end: iZoomLength / data1.length * 100
          })
      }

      var myChartPVF = echarts.init(document.getElementById('myChartPVF'));
      myChartPVF.clear()
      
      var optionpvf = {
        title: {
          text: this.chartTitle,
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          y: 10,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params) {
            var str = '';
            str += params[0].name;
            str += '<br/>' + that.equipDesc[params[0].dataIndex]
            str += '<br/><br/>'
            str += '峰平谷利用率(%)'
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              if (params[i].seriesName == '基准电价') {
                str += '<br/>' + params[i].seriesName + ':' + params[i].value[1] + ',' + params[i].value[2];
              } else {
                str += '<br/>' + params[i].seriesName + ':' + params[i].value;
              }
            }
            return str;
          }
        },
        legend: {
          data: ['峰', '平', '谷', '平均电价', '基准电价'],
          x: 'right',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        grid: {
          left: '6%',
          bottom: 50,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12
              }
            },
            data: this.dataLabel
          },
          {
            type: 'category',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: this.dataLabel
          },
          {
            type: 'category',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: this.xAxis
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '%',
            nameTextStyle: {
              color: '#fff',
              fontSize: 16
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                fontWeight: 'normal',
                fontSize: 16
              }
            }
          },
          {
            name: '平均电价(元)',
            type: 'value',
            nameTextStyle: {
              color: '#fff',
              fontSize: 16
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              textStyle: {
                fontWeight: 'normal',
                fontSize: 16
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        dataZoom: zoomConfig,
        series: [
          {
            name: '峰',
            data: this.dataset[0],
            type: 'bar',
            color: serColors[0],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            }
          },/*
          {
            name: '峰',
            data: this.shadowBar,
            type: 'bar',
            xAxisIndex: 1,
            color: 'transparent',
            itemStyle: {
              normal: {
                barBorderColor: 'rgb(134, 201, 244)',
                borderType: 'dotted'
              }
            }
          },*/
          {
            name: '平',
            data: this.dataset[1],
            type: 'bar',
            color: serColors[1],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            }
          },/*
          {
            name: '平',
            data: this.shadowBar,
            type: 'bar',
            xAxisIndex: 1,
            color: 'transparent',
            itemStyle: {
              normal: {
                barBorderColor: 'rgb(134, 201, 244)',
                borderType: 'dotted'
              }
            }
          },*/
          {
            name: '谷',
            data: this.dataset[2],
            type: 'bar',
            color: serColors[2],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            }
          },/*
          {
            name: '谷',
            data: this.shadowBar,
            type: 'bar',
            xAxisIndex: 1,
            color: 'transparent',
            itemStyle: {
              normal: {
                barBorderColor: 'rgb(134, 201, 244)',
                borderType: 'dotted'
              }
            }
          },*/
          {
            name: '平均电价',
            data: this.dataset[3],
            type: 'line',
            yAxisIndex: 1,
            color: '#70DF00',
            symbol: 'diamond',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#70DF00',
                    fontSize: 14,
                    fontStyle: 'bold'
                  }
                }
              }
            }
          },/*
          {
            name: '最优电价',
            data: this.dataset[4],
            type: 'line',
            yAxisIndex: 1,
            color: '#009a44',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                }
              }
            }
          }*/
          {
            name: '基准电价',
            data: this.pvfBasePrice,
            type: 'k',
            yAxisIndex: 1,
            itemStyle: {
              color: 'rgba(106,163,106,0.3)',
              color0: 'rgba(106,163,106,0.3)',
              borderColor: '#6aa36a',
              borderColor0: '#6aa36a'
            }
          }
        ]
      };
      // 5：展示数据
      myChartPVF.setOption(optionpvf);




 var myChart2 = echarts.init(document.getElementById('myChartPVF2'));
      myChart.clear()
      if (this.dataLabel.length == 0) {
        return;
      }

      var option2 = {
        title: {
          text: (queryArgs.QueryColumnGroup == 'energy' ? '峰平谷生产能耗占比(kWh)' : '峰平谷生产时间占比(H)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          y: 50,
          left: 'center'
        },
        color: serColors,
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            name: (queryArgs.QueryColumnGroup == 'energy' ? '峰平谷生产能耗占比' : '峰平谷生产时间占比'),
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: this.dataset,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            itemStyle: {
              normal: {
                  label: {
                    show: true,
                    position: 'inner',
                    fontSize: 20,
                    align: "left",
                    color: '#005786',
                    formatter: function (p) {
                      return p.data.name + ':' + p.data.value + (queryArgs.QueryColumnGroup == 'energy' ? ' kWh' : ' Hour') + '\r\n' + p.percent + '%';
                    }
                  }
              }
            }
          }
        ]
      };
      // 5：展示数据
      myChart2.setOption(option2);










    }
  }
};
</script>

<style lang="less" scoped >
#pvf1 {
  position: relative;
  width: 100%;
  background-color: #1b2445;
  height: 100%;
  box-sizing: border-box;
  .box {
    position: relative;
    width: 100%;
    height: 100%;
  }
   element.style {
     width: 100%;
   }
}

</style>